<template>
  <div>
    <div>
      <el-input 
        v-model="form.keywords" 
        class="fl w-300" 
        placeholder="请输入搜索内容">
      </el-input>
      <el-date-picker
        class="fl"
        clearable
        v-model="date_range"
        type="daterange"
        format="yyyy-MM-dd"
        placeholder="选择日期范围"
        @change="handleDateChange"
        style="margin-left:15px">
      </el-date-picker>
      <el-button
        type="primary"
        @click="searchMessage"
        style="margin-left:15px;">
        搜索
      </el-button>
    </div>
    <div class="m-t-20">
      <el-table 
        :data="messageList"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>    
        <el-table-column 
          label="消息类型"
          prop="type"></el-table-column>
        <el-table-column 
          label="发起人"
          prop="sender"></el-table-column>
        <el-table-column 
          label="消息主题"
          prop="theme">
          <template scope="scope">
            <el-button type="text"  @click="jumpMessage(scope.row.status,scope.row.theme_url_web, scope.row.id)">{{scope.row.theme}}</el-button>
          </template> 
        </el-table-column>
        <el-table-column 
          label="消息时间"
          prop="create_time">
          <template scope="scope">
            <span>{{scope.row.create_time | toTime}}</span>  
          </template>  
        </el-table-column>
        <el-table-column 
          label="当前状态"
          prop="status">
          <template scope="scope">
            <div>
              <span v-if="scope.row.status === 10">未处理</span>
              <span v-if="scope.row.status === 20">已处理</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top:20px;"></div>
    <div>
      <div class="fl">
        <el-button @click="handleReadMessage">已读</el-button>
        <el-button @click="handleDeleteMessage">删除</el-button>
      </div>
      <!--分页-->
      <div class="fr">
        <el-pagination
          :page-sizes="[100,200,300,400]"
          :page-size="this.form.limit"
          :total="this.dataCount"
          :current-page="this.form.page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="messageInfo.title"
      v-if="messageInfo !== null"
      v-model="dialogVisible"
      size="tiny">
      <span>{{messageInfo.content}}</span>
      <div class="hr"></div>
      <span>点击查看更多：<a :href="messageInfo.url" target="_blank" style="text-decoration: underline;">{{messageInfo.url}}</a></span>
    </el-dialog>
  </div>
</template>
<style>
.hr {
    margin-bottom: 10px;
    margin-top:10px;
    height: 1px;
    background: #000000;
  }
</style>

<script>
  import http from '../../../assets/js/http.js'
  export default {
    data() {
      return {
        tableData: [],
        messageList: [], // 消息中心列表数据
        dataCount: null, // 消息中心列表总数
        form: {          // 访问请求列表数据
          date_range: null,
          keywords: null,
          limit: 100,
          page: 1
        },
        messageInfo: null,
        dialogVisible: false,
        selectArr: [],
        date_range: null
      }
    },
    created() {
      store.dispatch('showLeftMenu', true)
      // 获取消息中心列表
      this.getMessageList()
    },
    methods: {
      searchMessage() { // 搜索消息中心列表
        this.getMessageList()
      },
      getMessageList() { // 获取消息中心列表
        let inputData = {
          params: this.form
        }
        this.apiGet(`msg/center`, inputData).then((res) => {
          if (res.code === 200) {
            this.messageList = res.data.list
            this.dataCount = res.data.dataCount
            return
          }
          _g.dealError(this, res)
        })
        store.dispatch('setMessageUnRead')
      },
      async getMessageDetail(id) {
        let str = null
        let res = await this.apiGet(`msg/center/${id}`)
        str = this.promiseHandler(str, res)
        return str
      },
      deleteMessage(arr) {
        if (arr && arr.length > 0) {
          let postData = {
            ids: arr
          }
          this.apiPost(`msg/center/deletes`, postData).then((res) => {
            if (res.code === 200) {
              _g.toastMsg(this, 'success', res.data ? res.data : '操作成功')
              this.getMessageList()
              return
            }
            _g.dealError(this, res)
          })
        }
      },
      async readMessage(arr, type) { // 批量标记已处理
        let postData = {
          ids: arr
        }
        let str = null
        let promise = await this.apiPost(`msg/center/deals`, postData)
        str = this.promiseHandler(str, promise)
        if (str === null) {
          return false
        }
        if (type !== 1) {
          _g.toastMsg(this, 'success', '操作成功')
        }
        this.getMessageList()
        return true
      },
      handleDateChange(str) {
        let arr = []
        if (str) {
          arr = str.split(' - ')
          this.form.date_range = arr
        } else {
          this.form.date_range = []
        }
      },
      handleSelectionChange(arr) {
        // console.log('handleSelectionChange', arr)
        this.selectArr = []
        if (arr && arr.length > 0) {
          _(arr).forEach((res) => {
            this.selectArr.push(res.id)
          })
        }
      },
      handleSizeChange(size) { // 每页条数改变时间
        // console.log('handleSizeChange', size)
        this.form.limit = size
        this.getMessageList()
      },
      handleCurrentChange(val) {
        this.form.page = val
        this.getMessageList()
      },
      handleDeleteMessage() {
        if (this.selectArr && this.selectArr.length > 0) {
          this.deleteMessage(this.selectArr)
        }
      },
      handleReadMessage() {
        if (this.selectArr && this.selectArr.length > 0) {
          this.readMessage(this.selectArr)
        }
      },
      async jumpMessage(status, theme_url_web, id) { // 查看更多消息内容
        // 如果该消息的状态是10 未处理，则访问已读接口
        if (status === 10) {
          let arr = []
          arr.push(id)
          // 加入1的目的是：当点击消息主题时，没必要显示 操作成功
          await this.readMessage(arr, 1)
        }
        if (theme_url_web) {
          window.open(theme_url_web, "_blank")
        } else {
          // 获取消息详情
          this.messageInfo = await this.getMessageDetail(id)
          // 打开对话框，显示数据
          if (this.messageInfo) {
            this.dialogVisible = true
          }
        }
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// centerList.vue?15aa6228